export const COMPONENTS_ENUM = {
    ACC_OVERVIEW: 'ACCOUNTS',
    COMPARISON: 'COMPARISON',

    POSTS: 'POSTS',
    POST_CHART: 'POST_CHART',
    METADATA: 'METADATA',
    HASHTAGS: 'HASHTAGS',
    COMMENTS: 'COMMENTS',
    PRODUCTS: 'PRODUCTS',

    CHART: 'CHART',
    TABLE: 'TABLE',
} as const;

export type Components = (typeof COMPONENTS_ENUM)[keyof typeof COMPONENTS_ENUM];

export const insightsTabs = [
    { display: 'Chart', value: COMPONENTS_ENUM.CHART },
    { display: 'Table', value: COMPONENTS_ENUM.TABLE },
];

export const postTabs = [
    { display: 'Chart', value: COMPONENTS_ENUM.POST_CHART },
    { display: 'Metadata', value: COMPONENTS_ENUM.METADATA },
    { display: 'Users + Hastags', value: COMPONENTS_ENUM.HASHTAGS },
    // { display: 'Comments', value: COMPONENTS_ENUM.COMMENTS },
    // { display: 'Products', value: COMPONENTS_ENUM.PRODUCTS },
];
